import Swiper from 'swiper';
import {A11y, Navigation, Pagination, FreeMode, Thumbs, Autoplay, EffectFade} from 'swiper/modules';
(window as typeof window & {Swiper: typeof Swiper}).Swiper = Swiper;



export function initSwiper() {
    const startSliderEl = document.querySelector<HTMLElement>('.start-slider');
    if (startSliderEl) new Swiper(startSliderEl, {
        modules: [Navigation, A11y, Autoplay],
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },

        navigation: {
            nextEl: '.swiper-arrow_next',
            prevEl: '.swiper-arrow_prev'
        },
    });

    const detailCSliderEl = document.querySelector<HTMLElement>('.detailc-slider');
    if (detailCSliderEl) new Swiper(detailCSliderEl, {
        modules: [Navigation, A11y, Autoplay],
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },

        navigation: {
            nextEl: '.detailc-arrow_next',
            prevEl: '.detailc-arrow_prev'
        },
    });

    const placingSliderEls = document.querySelectorAll<HTMLElement>('.placing-slider');
    placingSliderEls.forEach((placingSliderEl) => {
        const prevEl = placingSliderEl.querySelector<HTMLElement>('.placing-arrow_prev');
        const nextEl = placingSliderEl.querySelector<HTMLElement>('.placing-arrow_next');

        new Swiper(placingSliderEl, {
            modules: [Navigation, A11y, Autoplay],
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,

            navigation: {
                nextEl: nextEl || undefined,
                prevEl: prevEl || undefined
            },
        });
    });

    const modalLeftdSliderEls = document.querySelectorAll<HTMLElement>('.modal-leftd-slider');
    modalLeftdSliderEls.forEach((modalLeftdSliderEl) => {
        const prevEl = modalLeftdSliderEl.querySelector<HTMLElement>('.modal-leftd-arrow_prev');
        const nextEl = modalLeftdSliderEl.querySelector<HTMLElement>('.modal-leftd-arrow_next');

        new Swiper(modalLeftdSliderEl, {
            modules: [Navigation, A11y],
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,

            navigation: {
                nextEl: nextEl || undefined,
                prevEl: prevEl || undefined
            },
        });
    });

    
    const shipSliderEl = document.querySelector<HTMLElement>('.ship-slider');
    if (shipSliderEl) new Swiper(shipSliderEl, {
        modules: [Navigation, A11y, Autoplay],
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },

        navigation: {
            nextEl: '.ship-arrow_next',
            prevEl: '.ship-arrow_prev'
        }
    });

    const detailShipSliderEl = document.querySelector<HTMLElement>('.detail-ship-slider');
    if (!detailShipSliderEl) return;

    const detailShipSlider = new Swiper(detailShipSliderEl, {
        modules: [Navigation, A11y, EffectFade],
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },

        navigation: {
            nextEl: '.detail-ship-arrow_next',
            prevEl: '.detail-ship-arrow_prev'
        }
    });

    const detailShipPaginations = document.querySelectorAll<HTMLElement>(
        '.detail-ship-slider .detail-ship-slider-pagination'
    );

    const updateDetailShipPagination = () => {
        const current = detailShipSlider.realIndex + 1;
        const totalFromSwiper = detailShipSlider.slides.length;
        const totalFromDom = document.querySelectorAll('.detail-ship-slider .swiper-slide').length;
        const total = totalFromSwiper || totalFromDom;
        const fractionText = `${current}/${total}`;

        detailShipPaginations.forEach((paginationEl) => {
            paginationEl.textContent = fractionText;
        });
    };

    detailShipSlider.on('init', updateDetailShipPagination);
    detailShipSlider.on('observerUpdate', updateDetailShipPagination);
    updateDetailShipPagination();
    detailShipSlider.on('slideChange', updateDetailShipPagination);
}

